import create from 'zustand';

interface EnviromentStore {
  isApp: boolean | undefined;
  setIsApp: (isApp: boolean) => void;
}

const initialState = {
  isApp: false,
};

const useEnviromentStore = create<EnviromentStore>((set) => ({
  ...initialState,
  setIsApp: (isApp: boolean) => set(() => ({ isApp })),
}));

export default useEnviromentStore;
